import { defineMessage } from '@lingui/macro'

export const userActiveText = defineMessage({
  id: 'administration.users.account_status.active',
  message: 'Account active',
})
export const userInactiveText = defineMessage({
  id: 'administration.users.account_status.inactive',
  message: 'Account inactive',
})
export const emailSendingFailedError = defineMessage({
  id: 'administration.users.modal.sending_email_failed',
  message: 'Email message with activation code could not be sent. Please try again later.',
})
